class Hoverable extends React.Component {
  state = {
    hovered: false,
  };

  onMouseEnter = () => this.setState({ hovered: true });

  onMouseLeave = () => this.setState({ hovered: false });

  render() {
    const { hovered } = this.state;

    return this.props.render({
      hovered,
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave,
    });
  }
}

Hoverable.propTypes = {
  render: PropTypes.func.isRequired,
};

export default Hoverable;
